/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateMarketMakerOptions,
  CreateMarketMakerStatus201,
  CreateMarketMakerStatus400,
  CreateMarketMakerStatus401,
  CreateMarketMakerStatus403,
  CreateMarketMakerStatus404,
  CreateMarketMakerStatus409,
  CreateMarketMakerStatus500,
} from '../types/CreateMarketMaker'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createMarketMaker } from '../clients/createMarketMaker'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createMarketMakerMutationKey = () => [{ url: '/v1/market-makers' }] as const

export function createMarketMakerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createMarketMakerMutationKey()
  return mutationOptions<
    CreateMarketMakerStatus201,
    ResponseErrorConfig<
      | CreateMarketMakerStatus400
      | CreateMarketMakerStatus401
      | CreateMarketMakerStatus403
      | CreateMarketMakerStatus404
      | CreateMarketMakerStatus409
      | CreateMarketMakerStatus500
    >,
    CreateMarketMakerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createMarketMaker({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Create a market maker
 * {@link /v1/market-makers}
 */
export function useCreateMarketMaker<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateMarketMakerStatus201,
      ResponseErrorConfig<
        | CreateMarketMakerStatus400
        | CreateMarketMakerStatus401
        | CreateMarketMakerStatus403
        | CreateMarketMakerStatus404
        | CreateMarketMakerStatus409
        | CreateMarketMakerStatus500
      >,
      CreateMarketMakerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createMarketMakerMutationKey()

  const baseOptions = createMarketMakerMutationOptions(config) as UseMutationOptions<
    CreateMarketMakerStatus201,
    ResponseErrorConfig<
      | CreateMarketMakerStatus400
      | CreateMarketMakerStatus401
      | CreateMarketMakerStatus403
      | CreateMarketMakerStatus404
      | CreateMarketMakerStatus409
      | CreateMarketMakerStatus500
    >,
    CreateMarketMakerOptions,
    TContext
  >

  return useMutation<
    CreateMarketMakerStatus201,
    ResponseErrorConfig<
      | CreateMarketMakerStatus400
      | CreateMarketMakerStatus401
      | CreateMarketMakerStatus403
      | CreateMarketMakerStatus404
      | CreateMarketMakerStatus409
      | CreateMarketMakerStatus500
    >,
    CreateMarketMakerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateMarketMakerStatus201,
    ResponseErrorConfig<
      | CreateMarketMakerStatus400
      | CreateMarketMakerStatus401
      | CreateMarketMakerStatus403
      | CreateMarketMakerStatus404
      | CreateMarketMakerStatus409
      | CreateMarketMakerStatus500
    >,
    CreateMarketMakerOptions,
    TContext
  >
}
